<article>
  <h1>Contact Us</h1>
  <p>
    If you have any questions or concerns, please contact us at
    <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a>
  </p>
</article>
